// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@hardwoods/XDL/Utilities";
import { DatePickerPresentationProps } from "@insite/mobius/DatePicker";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface FilteredSearchFieldsStyle {
    searchFieldsWrapper?: InjectableCss;
    container?: InjectableCss;
    fromDate?: DatePickerPresentationProps;
    toDate?: DatePickerPresentationProps;
    containerWithPadding?: InjectableCss;
}

export const filteredSearchFieldsStyle: FilteredSearchFieldsStyle = {
    // Added for pages the the search filter build from cms
    container: {
        css: css`
            border: 1px solid ${color("common.border")};
            padding: 20px;
            margin-bottom: 20px;
            width: 100%;

            > div[class^="GridItemStyle"] {
                padding: 3px;
            }

            div[class^="GridItemStyle"] {
                align-items: flex-end;
            }
        `,
    },
    // wrapper for search filter that not combined from cms
    containerWithPadding: {
        css: css`
            border: 1px solid ${color("common.border")};
            padding: 25px 20px;
            margin-bottom: 20px;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
        `,
    },
    searchFieldsWrapper: {
        css: css`
            width: 100%;
            padding: 5px;
        `,
    },
    fromDate: {
        cssOverrides: {
            formField: css`
                padding-right: 10px;
            `,
        },
    },
    toDate: {
        cssOverrides: {
            formField: css`
                padding-left: 10px;
            `,
        },
    },
};
